export enum SourceType {
  email = 'email',
  sms = 'sms',
  web = 'web',
}

export interface ClickThroughSource {
  page: string;
  element: string;
  sourceType: SourceType;
}

export interface ClickThroughSourceLocalStorageValue extends ClickThroughSource {
  pathname: string;
}
